<template>
  <div
    :style="{
     
      flexWrap: 'wrap',
      minHeight: '600px',
      borderRadius: '5%',
    }"
    class="white pa-3 radius5"
  >
    <div :style="{ flex: '45%', margin: '0%' }">
      <v-card flat>
        <v-card-title>
          <b>
            TOP PRODUCTOS VENDIDOS
          </b>
        </v-card-title>
        <v-card-text>
          <div :style="{ marginBlock: '5px' }">
            <div
              :style="{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                flexWrap: 'wrap',
                marginBottom: '10px'
              }"
            >
              <span style="font-weight:600">Desde</span>

              <date-picker
                v-model="start"
                @dateSelected=" (val) => { start = val;}"
                type="date"
                :styling-mode="'outlined'"
                :style="{ width: '140px' }"
              />

              <span style="font-weight:600">Hasta</span>

              <date-picker
                v-model="end"
                type="date"
                @dateSelected=" (val) => { end = val;}"
                :styling-mode="'outlined'"
                :style="{ width: '140px' }"
              />

              <DxButton
                text="Aplicar"
                type="default"
                styling-mode="contained"
                @click="getTopProducts()"
              />
            </div>
            <div
              :style="{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap'
              }"
            >
              <!-- Checkboxes -->
              <div :style="{ display: 'flex', gap: '20px' }">
                <DxCheckBox
                  :value="showProducts"
                  @value-changed="manageProducts"
                  text="Ver Productos"
                />

                <DxCheckBox
                  :value="showServices"
                  @value-changed="manageServices"
                  text="Ver Servicios"
                />

                <DxCheckBox
                  :value="mostrarIVA"
                  @value-changed="manageMostrarIVA"
                  text="Mostrar con IVA"
                />
              </div>
            </div>
          </div>
          <spinner v-if="loading" />
          <GeneralFilter
            :search="{}"
            :filterEndpoint="filterPromise"
            @filtered="filterHandler"
            @emptyFilter="clearFilter"
            :is-auto-scrolled="true"
            v-else
          >
            <DxDataGrid
              :data-source="visibleProducts"
              key-expr="ID_Item"
              :show-row-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :scrolling="{ useNative: true }"
              :column-auto-width="true"
              @exporting="onExporting"
            >
              <DxExport :enabled="true" />

              <DxPaging :page-size="5" />
              <!--  <DxPaging :page-size="10"/> -->
              <DxPager
                :visible="true"
                :show-page-size-selector="false"
                :show-info="true"
                :show-navigation-buttons="true"
              />
              <DxColumn data-field="ID_Item" caption="ID"></DxColumn>

              <DxColumn
                data-field="ItemDescription"
                caption="Producto/Servicio"
              />
              <DxColumn
                data-field="sold"
                data-type="number"
                :value-format="{ type: 'fixedPoint', precision: 2 }"
                caption="Cantidad vendida"
              />
              <DxColumn
                :data-field="totalField"
                data-type="number"
                :value-format="{ type: 'fixedPoint', precision: 2 }"
                caption="Total"
              />
              <DxSummary>
                <DxTotalItem
                  column="ID_Item"
                  summary-type="count"
                  display-format="Total: {0}"
                />

                <DxTotalItem
                  column="sold"
                  summary-type="sum"
                  value-format="fixedPoint"
                  display-format="{0}"
                />

                <DxTotalItem
                  :column="totalField"
                  summary-type="sum"
                  value-format="currency"
                  display-format="{0}"
                />
            </DxSummary>
            </DxDataGrid>
          </GeneralFilter>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxExport,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import GeneralFilter from "../GeneralFilter.vue";
import DxButton from "devextreme-vue/button";
import DatePicker from "../../components/DatePicker";
import moment from "moment";
import { DxCheckBox } from "devextreme-vue/check-box";
import { multipleCriteriaFilterV2 } from "../../helpers/object";
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver-es';
import spinner from "./spinner.vue";
ChartJS.register(ArcElement, Tooltip, Legend);
export default {
  name: "TopProductChart",
  components: {
    DxDataGrid,
    DxColumn,
    GeneralFilter,
    DxPaging,
    DxButton,
    DxCheckBox,
    DxPager,
    DatePicker,
    DxExport,
    DxSummary,
    DxTotalItem,
    spinner,
  },
  props:{
    branch:{
      type:Number,
      default: 0,
    },
    ambiente:{
      type:Number,
      default: 1,
    },
    autoLoad: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      start: moment().format("01/MM/YYYY"),
      end: moment().format("DD/MM/YYYY"),
      products: [],
      services: [],
      topCustomers: [],
      topProducts: [],
      allData: [],
      activeP: "dia",
      activeC: "dia",
      activePF: "Dias",
      countCustomers: [],
      showServices: true,
      showProducts: true,
      dataP: {
        labels: ["Actual", "Anterior", "Dos anteriores"],
        datasets: [
          {
            backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
            data: [10, 10, 10],
          },
        ],
      },
      topProductsFiltered: [],
      isFiltered: false,
      Currency: null,
      mostrarIVA: false,
      loading: false,
    };
  },
  computed:{
    totalField() {
      return this.mostrarIVA ? "valIVA" : "val";
    },
    visibleProducts(){
      return this.allData.filter(i => 
        (this.showProducts && i.ItemType === "PRODUCT") ||
        (this.showServices && i.ItemType === "SERVICE")
      )
    }
  },
  mounted() {
    this.Currency = JSON.parse(localStorage.getItem("branch")).Currency;
    if (this.autoLoad) {
      this.loadInitialData();
    }
    /* this.getCustomersDay(); */
  },
  methods: {
    loadInitialData() {
      return this.getTopProducts();
    },
    updateVisibleProducts() {
      let data = []
      if (this.showProducts) {
        data = data.concat(this.products)
      }
      if (this.showServices) {
        data = data.concat(this.services)
      }
      this.topProducts = data
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('TopProductosVendidos');

      exportDataGrid({
        component: e.component,
        worksheet,
        topLeftCell: { row: 4, column: 1 },
      }).then((cellRange) => {
        // header
        const headerRow = worksheet.getRow(2);
        headerRow.height = 30;
        worksheet.mergeCells(2, 1, 2, 4);

        headerRow.getCell(1).value = 'Top Productos Vendidos';
        headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
        headerRow.getCell(1).alignment = { horizontal: 'center' };

        // footer
        const footerRowIndex = cellRange.to.row + 2;
        const footerRow = worksheet.getRow(footerRowIndex);
        worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 4);

        footerRow.getCell(1).value = '-';
        footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
        footerRow.getCell(1).alignment = { horizontal: 'right' };
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'TopProductosVendidos.xlsx');
        });
      });
      e.cancel = true;
    },
    setCurrency() {
      this.topProducts.map((customer) => {
        customer.amountFormatted = `${this.Currency}${customer.amount}`;
      });
    },
    filterHandler(response) {
      this.isFiltered = true;
      this.allData = response;
    },
    clearFilter() {
      this.isFiltered = false;
      this.allData = this.topProducts;
    },
    filterPromise(filterObj) {
      const filterArray = ["ID_Item", "ItemDescription", "sold", "val", "valIVA"];
      const data = this.topProducts;
      return new Promise((resolve, reject) => {
        try {
          resolve(
            multipleCriteriaFilterV2(filterArray, filterObj, data)
          );
        } catch (error) {
          reject(error);
        }
      });
    },
    manageServices(e) {
      this.showServices = e.value
      this.updateVisibleProducts()
    },
    manageProducts(e) {
      this.showProducts = e.value
      this.updateVisibleProducts()
    },
    manageMostrarIVA(e) {
      this.mostrarIVA = e.value;
    },
    getTopCustomers() {
      const params = {
        branch: this.branch,
        ambiente: this.ambiente,
        start: this.start,
        end: this.end,
      };
      return this.$API.dashboard.getTop(params).then((response) => {
        this.topCustomers = response;
      });
    },
    getTopCustomersRange() {
      let fstart = moment(this.start).format("yyyy-dd-mm");
      let fend = moment(this.end).format("yyyy-dd-mm");
      this.$API.dashboard
        .getTopCustomersRange(fstart, fend)
        .then((response) => {
          this.topCustomers = response;
          this.activeC = "dia";
          this.setCurrency();
        });
    },
    getTopCustomersw() {
      this.$API.dashboard.getTopCustomersw().then((response) => {
        this.topCustomers = response;
        this.activeC = "semana";
        this.setCurrency();
      });
    },
    getTopCustomersm() {
      this.$API.dashboard.getTopCustomersm().then((response) => {
        this.topCustomers = response;
        this.activeC = "mes";
        this.setCurrency();
      });
    },
    getTopCustomersy() {
      this.$API.dashboard.getTopCustomersy().then((response) => {
        this.topCustomers = response;
        this.activeC = "año(actual)";
        this.setCurrency();
      });
    },
    //pastel graphic
    getCustomersYear() {
      this.$API.dashboard.CustomersYear().then((response) => {
        this.countCustomers = response;
        this.activePF = "años";
        this.dataP = {
          labels: ["Actual", "Anterior", "Dos anteriores"],
          datasets: [
            {
              backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
              data: this.countCustomers,
            },
          ],
        };
      });
    },
    getCustomersMonth() {
      this.$API.dashboard.CustomersMonth().then((response) => {
        this.countCustomers = response;
        this.activePF = "meses";
        this.dataP = {
          labels: ["Actual", "Anterior", "Dos anteriores"],
          datasets: [
            {
              backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
              data: this.countCustomers,
            },
          ],
        };
      });
    },
    getCustomersDay() {
      this.$API.dashboard.CustomersDay().then((response) => {
        this.countCustomers = response;
        this.dataP = {
          labels: ["Actual", "Anterior", "Dos anteriores"],
          datasets: [
            {
              backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
              data: this.countCustomers,
            },
          ],
        };
        this.activePF = "dias";
      });
    },
    //end pastel graphic
    async getTopProducts() {
      try {
        const params = {
          branch: this.branch,
          ambiente: this.ambiente,
          start: this.start,
          end: this.end,
        }
        this.loading = true;      
        const response = await this.$API.dashboard.getProducts(params)
        const data = response.map(i => ({
          ...i,
          sold: Number(i.sold),
          val: Number(i.val),
          valIVA: Number(i.valIVA)
        }))
        this.topProducts = data
        this.allData = data
      } catch (error) {
        console.warn(error);
        
      }finally{
        this.loading = false;
      }
      
      
    },
    getTopProductsRange() {
      this.$API.dashboard
        .getProductsRange(
          new Date(this.formatDate(this.start)),
          new Date(this.formatDate(this.end))
        )
        .then((response) => {
          this.allData = response;
          // Verifica los datos recibidos
          // Filtrar productos y servicios
          this.products = response.filter((item) => item.ItemType === 'PRODUCT');
          this.services = response.filter((item) => item.ItemType === 'SERVICE');
          // Actualizar topProducts
          this.topProducts = [...this.products, ...this.services];
          this.activeP = "dia";
          this.setCurrency();
        });
    },
    formatDate(date) {
      const parts = date.split("/");
      const aux = parts[0];
      parts[0] = parts[1];
      parts[1] = aux;
      return parts.join("/");
    },
    getTopProductsw() {
      this.$API.dashboard.getProductsw().then((response) => {
        this.topProducts = response;
        this.activeP = "Semana";
      });
    },
    getTopProductsm() {
      this.$API.dashboard.getProductsm().then((response) => {
        this.topProducts = response;
        this.activeP = "mes";
      });
    },
    getTopProductsy() {
      this.$API.dashboard.getProductsy().then((response) => {
        this.topProducts = response;
        this.activeP = "año(actual)";
      });
    },
  },
};
</script>
<style scoped>
.number-statistics .c-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 40px;
  border-radius: 8px;
}

.dx-theme-generic-typography h3 {
  color: #000000;
}

.table-statistics .purple {
  background-color: purple;
}

.table-statistics .orange {
  background-color: orange;
}

.table-statistics h4 {
  color: #fff;
  padding: 10px 20px;
}
.dx-field {
  display: flex;
  align-items: center;
}
.dx-field-label {
  margin-right: 10px;
}
</style>
